export const isKidProfile = (perfiles, gamification_id) => {
  //Se determina si el perfil es kid o no
  const currentProfile = perfiles?.find(
    perfil => gamification_id === perfil?.gamification_id,
  );
  const isKid = currentProfile?.is_kids;

  if (typeof isKid === 'string') return isKid.toLocaleLowerCase() === 'true' ? 1 : 0;

  return isKid ? 1 : 0;
};
